<template>
  <location-tree />
</template>
<script>
import LocationTree from '@/components/locations/LocationTree.vue'
export default {
  name: 'LocationView',
  components: {
    LocationTree
  }
}
</script>
<style lang="scss" scoped></style>
